// Lightbox modal driven by the native <dialog> element.

// Pure: map a trigger's data-* attributes to the lightbox content.
export function lightboxContent(dataset) {
  return {
    img: dataset.img,
    title: dataset.title,
    meta: `${dataset.category} · ${dataset.desc}`,
  }
}

// Fetch each zoom image once, ahead of the click that opens it.
export function preloader(createImage = () => new Image()) {
  const requested = new Set()
  return (src) => {
    if (!src || requested.has(src)) return
    requested.add(src)
    createImage().src = src
  }
}

export function initLightbox(doc = document) {
  const dialog = doc.querySelector(".lightbox")
  if (!dialog || typeof dialog.showModal !== "function") return

  const img = dialog.querySelector("img")
  const title = dialog.querySelector("figcaption strong")
  const meta = dialog.querySelector("figcaption small")
  const closeBtn = dialog.querySelector(".lightbox-close")
  const prevBtn = dialog.querySelector(".lightbox-prev")
  const nextBtn = dialog.querySelector(".lightbox-next")

  const preload = preloader()
  let triggers = []
  let currentIndex = 0

  const updateLightbox = (index) => {
    if (triggers.length === 0) return
    currentIndex = index
    const content = lightboxContent(triggers[currentIndex].dataset)
    img.src = content.img
    img.alt = content.title
    title.textContent = content.title
    meta.textContent = content.meta
  }

  // Get all visible gallery items dynamically
  const getVisibleTriggers = () => {
    return Array.from(doc.querySelectorAll(".gallery-grid li:not([hidden]) button"))
  }

  doc.querySelectorAll(".gallery-grid button").forEach((trigger) => {
    trigger.addEventListener("pointerenter", () => preload(trigger.dataset.img))
    trigger.addEventListener("focus", () => preload(trigger.dataset.img))
    trigger.addEventListener("click", () => {
      triggers = getVisibleTriggers()
      if (triggers.length === 0) return // Fallback
      
      currentIndex = triggers.indexOf(trigger)
      if (currentIndex === -1) currentIndex = 0
      
      updateLightbox(currentIndex)
      dialog.showModal()
    })
  })

  prevBtn.addEventListener("click", (e) => {
    e.stopPropagation()
    currentIndex = (currentIndex > 0) ? currentIndex - 1 : triggers.length - 1
    updateLightbox(currentIndex)
  })

  nextBtn.addEventListener("click", (e) => {
    e.stopPropagation()
    currentIndex = (currentIndex < triggers.length - 1) ? currentIndex + 1 : 0
    updateLightbox(currentIndex)
  })

  closeBtn.addEventListener("click", () => dialog.close())
  
  // Close when clicking the backdrop (outside the framed figure and buttons).
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) dialog.close()
  })

  // Keyboard navigation
  dialog.addEventListener("keydown", (event) => {
    if (event.key === "ArrowLeft") {
      currentIndex = (currentIndex > 0) ? currentIndex - 1 : triggers.length - 1
      updateLightbox(currentIndex)
    } else if (event.key === "ArrowRight") {
      currentIndex = (currentIndex < triggers.length - 1) ? currentIndex + 1 : 0
      updateLightbox(currentIndex)
    }
  })
}
